import { useDispatch } from "react-redux";

import { ChatService } from "../api";
import { setGlobalMessages } from "../redux/slices/globalChat";
import { useQuery, type UseQueryResult } from "react-query";
import { useTypedSelector } from "../redux/store";
import { type MessageResultPaginatedResult } from "../api/generated/data-contracts";

interface Props {
  offset: number | undefined;
  limit: number | undefined;
}

export const useGetAllGlobalMessages = ({
  offset,
  limit
}: Props): UseQueryResult<MessageResultPaginatedResult, unknown> => {
  const dispatch = useDispatch();

  const userJwt = useTypedSelector((state) => state.auth.value);

  return useQuery({
    queryKey: ["getAllGlobalMessages", offset, limit],
    queryFn: async () => {
      const response = await ChatService.globalList(
        { offset, limit },
        {
          headers: {
            Authorization: `Bearer ${userJwt}`
          }
        }
      );
      return response.data;
    },
    onSuccess: (data) => {
      if (data?.results) {
        dispatch(setGlobalMessages(data.results));
      }
    },
    refetchOnWindowFocus: false
  });
};
